<template>
    <v-app light>
        <v-content class="main">
            <section>
                <v-parallax src="../../static/coding.jpg" height="600">
                    <v-layout column align-center justify-center class="white--text">
                        <img :src="'../../static/profile_picture_round.png'" height="150"/>
                        <h1 class="white--text mt-2 mb-3 display-1 text-xs-center">Yanis Tam</h1>
                        <div class="subheading mb-4 text-xs-center">Front-End Web Developer - Freelance</div>
                        <div class="subheading mb-2 text-xs-center">
                            <a href="https://gitlab.com/Madorakkusu" target="_blank" class="mx-3"><i class="fab fa-gitlab display-1 white--text"></i></a>
                            <a href="https://github.com/Madorakkusu" target="_blank" class="mx-3"><i class="fab fa-github display-1 white--text"></i></a>
                            <a href="https://www.linkedin.com/in/yanis-tam/" target="_blank" class="mx-3"><i class="fab fa-linkedin-in display-1 white--text"></i></a>
                        </div>
                        <v-btn id="contactButton" rounded class="grey darken-3 mt-4" dark large v-on:click="goToContact">
                            Contact
                        </v-btn>
                    </v-layout>
                </v-parallax>
            </section>

            <section>
                <v-layout column wrap class="my-5" align-center>
                    <v-flex xs12 sm4 class="my-3">
                        <div class="text-xs-center">
                            <h2 class="headline white--text">Hi there 👋</h2>
                            <span class="subheading white--text">
                                Let me introduce myself, I am...
                            </span>
                        </div>
                    </v-flex>
                    <v-flex xs12>
                        <v-container grid-list-xl>
                            <v-layout row wrap align-start>
                                <v-flex xs12 md4>
                                    <v-card class="elevation-0 transparent">
                                        <v-card-title primary-title class="layout justify-center">
                                            <div class="headline text-xs-center white--text">Web Developer 🤓</div>
                                        </v-card-title>
                                        <v-card-text class="white--text">
                                            I graduated from Computer Sciences & Web Design and as of 2019, I already have 4 years of experience on the market 💪
                                            I am currently working @AB Tasty
                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                                <v-flex xs12 md4>
                                    <v-card class="elevation-0 transparent">
                                        <v-card-title primary-title class="layout justify-center">
                                            <div class="headline text-xs-center white--text">Musician 🎵</div>
                                        </v-card-title>
                                        <v-card-text class="white--text">
                                            🥁 Drums are by far my favorite instrument but I also love to sing, play guitar & bass.
                                            I like to compose & jam on my free time, call me if you want 😉.
                                            My favorite genres are Rock & Metal 🤘 but I'm open to every kind of music.
                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                                <v-flex xs12 md4>
                                    <v-card class="elevation-0 transparent">
                                        <v-card-title primary-title class="layout justify-center">
                                            <div class="headline white--text">Friendly & Passionate 🤡</div>
                                        </v-card-title>
                                        <v-card-text class="white--text">
                                            I do everything with passion & try my best 🥇
                                            I find everything interesting
                                            <br/>Also : beers 🍺.
                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-flex>
                </v-layout>
            </section>

            <v-jumbotron :height="300" dark>
                <v-container fill-height>
                    <v-layout align-center>
                        <v-flex text-xs-center>
                            <h2 class="headline white--text my-5">So far, I've worked with :</h2>
                            <div class="workplaces mt-3">
                                <img class="mx-5 my-3" :src="'../../static/logo-bnp.png'" height="50"/>
                                <img class="mx-5 my-3" :src="'../../static/logo-af.png'" height="50"/>
                                <img class="mx-5 my-3" :src="'../../static/logo-abt.png'" height="40"/>
                            </div>
                            <div class="workplaces mt-3">
                                <img class="mx-5 my-3" :src="'../../static/logo-arcadecrew.png'" height="60"/>
                                <img class="mx-5 my-3" :src="'../../static/logo-ehess.png'" height="60"/>
                                <img class="mx-5 my-3" :src="'../../static/flagship.svg'" height="70"/>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-jumbotron>

            <section>
                <v-layout column wrap class="my-5" align-center>
                    <v-flex xs12 sm4 class="my-3">
                        <div class="text-xs-center">
                            <h2 class="headline white--text">Provided services</h2>
                            <span class="subheading white--text">
                                This is what I can do for you !
                            </span>
                        </div>
                    </v-flex>
                    <v-flex xs12>
                        <v-container grid-list-xl>
                            <v-layout row wrap align-start>
                                <v-flex xs12 md4>
                                    <v-card class="elevation-0 transparent">
                                        <v-card-title primary-title class="layout justify-center">
                                            <div class="headline text-xs-center white--text">Simple website</div>
                                        </v-card-title>
                                        <v-card-text class="white--text">
                                            I can make you a website like this one with no advanced features, simply showing off
                                            your business or anything else.
                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                                <v-flex xs12 md4>
                                    <v-card class="elevation-0 transparent">
                                        <v-card-title primary-title class="layout justify-center">
                                            <div class="headline text-xs-center white--text">Advanced featured website</div>
                                        </v-card-title>
                                        <v-card-text class="white--text">
                                            As long as you have the idea, I can deliver ! From blogs to e-shop, we could talk about your needs and how
                                            you want your project while drinking a coffee comfortably !
                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                                <v-flex xs12 md4>
                                    <v-card class="elevation-0 transparent">
                                        <v-card-title primary-title class="layout justify-center">
                                            <div class="headline white--text">Short missions</div>
                                        </v-card-title>
                                        <v-card-text class="white--text">
                                            Maybe you'd need experienced hands and mind to help you with an existing project ?
                                            Maintenance, new features or expertise ?
                                            Can do !
                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-flex>

                </v-layout>
            </section>

            <section id="contact">
                <v-container grid-list-xl>
                    <v-layout row wrap justify-center class="my-5">
                        <v-flex xs12 sm4>
                            <v-card class="elevation-0 transparent">
                                <v-card-title primary-title class="layout justify-center">
                                    <div class="headline white--text">Interested ?</div>
                                </v-card-title>
                                <v-card-text class="white--text">
                                    If you're interested you should contact me,
                                    we will discuss of your project(s) together.
                                    And if we're ready to go on both side we will
                                    negociate the price range. I don't have fixed prices, so convince me !
                                </v-card-text>
                            </v-card>
                            <v-list class="transparent">
                                <v-list-tile>
                                    <v-list-tile-action>
                                        <v-icon class="white--text">phone</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title class="white--text">+33 06 49 76 52 97</v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile>
                                    <v-list-tile-action>
                                        <v-icon class="white--text">place</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title class="white--text">Paris, France</v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile>
                                    <v-list-tile-action>
                                        <v-icon class="white--text">email</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title class="white--text">yanistam@hotmail.fr</v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-list>
                        </v-flex>
                        <v-flex xs12 sm4 offset-sm1>
                            <v-card class="elevation-0 transparent">
                                <v-card-title primary-title class="layout justify-center">
                                    <div class="headline white--text">Contact me</div>
                                </v-card-title>
                                <v-card-text class="white--text">
                                    I'll try to give you an answer ASAP ! :)
                                </v-card-text>
                                <v-form action="https://formspree.io/yanistam@hotmail.fr"
                                        method="POST">
                                    <v-text-field color="white" placeholder="Your e-mail" type="email" name="_replyto"></v-text-field>
                                    <v-text-field color="white" multi-line placeholder="How can I help you ?" type="text" name="name"></v-text-field>
                                    <v-btn rounded type="submit" value="Send" class="white--text grey darken-3">Send</v-btn>
                                </v-form>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-container>
            </section>

            <v-footer class="grey darken-2">
                <v-layout row wrap align-center>
                    <v-flex xs12>
                        <div class="white--text ml-3">
                            Made by Yanis Tam
                            with <a class="white--text" target="_blank" href="https://vuetifyjs.com/">Vuetify</a>❤️
                            |
                            <a class="white--text" href="../../static/CV.pdf" target="_blank"> C.V</a>
                        </div>
                    </v-flex>
                </v-layout>
            </v-footer>
        </v-content>
    </v-app>
</template>

<script>
  export default {
    name: 'Landing',
    components: {
    },
    mounted() {
    },
    methods: {
      goToContact : function (e) {
        let smoothScroll = require('smoothscroll');
        e.preventDefault();
        let destination = document.getElementById('contact');
        smoothScroll(destination);
      }
    }
  }
</script>

<style lang="less">
    .workplaces {
        display: flex;
        justify-content: center;
        align-items: center;

        @media(max-width: 480px) {
            flex-direction: column;
        }
    }

    .logos {
        margin: 8px 32px;
    }

    .main {
        background: #343a40;
    }
</style>



// WEBPACK FOOTER //
// src/pages/Landing.vue